import { observer } from 'mobx-react'
import { useContext, useState } from 'react'
import { StoreContext } from '@store/Root.store'
import { SafariLogo } from '@components/SafariLogo'
import { forceRedirect } from '@methods/forceRedirect'
import { Button, Header, LoadingSpinner } from '@components/Generic'
import { API_URL } from '@constants/apiUrl'
import { cx } from '@/utils/cx'

export const ErrorIosBrowserNotSupportedPage = observer(() => {
  const store = useContext(StoreContext)
  const { errorIosBrowserNotSupportedPage: trans } = store.TranslationsState.translations

  const [isProceeding, setIsProceeding] = useState(false)

  const handleProceed = () => {
    setIsProceeding(true)

    const location = window.location.href
    const url = new URL(location)
    const goToSafariPathEncoded = url.searchParams.get('goToSafariPath') || ''
    const goToSafariPath = decodeURIComponent(goToSafariPathEncoded)

    if (goToSafariPath) {
      const goToSafariUrl = `x-safari-${API_URL}${goToSafariPath}`
      forceRedirect(goToSafariUrl)
    } else {
      setIsProceeding(false)
    }
  }

  return (
    <div className="page-container mobile-m-10 mobile-p-14-40">
      <div className="generic__error-ios-browser-not-supported__wrapper">
        <Header>{trans.header}</Header>

        <div className="generic__error-ios-browser-not-supported__icon">
          <SafariLogo />
        </div>

        <p className="generic__paragraph-centered">{trans.description}</p>

        <div className="layout__content-container-bottom-fixed">
          <div className="layout__centered-content">
            <Button
              onClick={handleProceed}
              disabled={isProceeding}
              className="button--min-w224"
              id="page-submit"
            >
              {isProceeding && <LoadingSpinner inButton />}
              <span
                className={cx(
                  'generic__button-text',
                  isProceeding && 'generic__button-text--loading'
                )}
              >
                {trans.proceed}
              </span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
})
